<div
  class="dashboard-material-theme dashboard-create-study-dialog"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <h4 fxFlexAlign="center" mat-dialog-title>Select new study type</h4>
  <mat-divider></mat-divider>
  <mat-dialog-content
    class="dashboard-create-study-dialog__content"
    fxLayout="column"
    fxFlexAlign="space-between stretch"
    fxLayoutGap="15px"
  >
    <label class="dashboard-create-study-dialog__content-label" fxFlexAlign="center" fxFlexOffset="20px">
      Type of survey</label
    >
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-button-toggle-group
        name="studyType"
        aria-label="Study Type"
        (change)="selectStudyType($event?.value)"
        fxLayout="row"
        fxLayout.lt-md="column"
        [value]="userStudyTypes.includes(StudyType.TIIM) ? StudyType.TIIM : StudyType.CC"
      >
        <mat-button-toggle
          class="dashboard-create-study-dialog__content-tiim"
          [ngStyle]="{
            opacity: selectedStudyType == StudyType.TIIM ? '1' : '0.4'
          }"
          *ngIf="userStudyTypes.includes(StudyType.TIIM)"
          [value]="StudyType.TIIM"
        >
          {{ 'TIIM Survey' | uppercase }}</mat-button-toggle
        >
        <mat-button-toggle
          class="dashboard-create-study-dialog__content-cc"
          [ngStyle]="{
            opacity: selectedStudyType == StudyType.CC ? '1' : '0.4'
          }"
          *ngIf="userStudyTypes.includes(StudyType.CC)"
          [value]="StudyType.CC"
        >
          {{ 'Career Compass Survey' | uppercase }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between end" fxFlexOffset="60px">
      <button mat-raised-button color="primary" mat-dialog-close>
        {{ 'Close' | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="createStudy()">
        {{ 'Create New Study' | uppercase }}
      </button>
    </div>
  </mat-dialog-content>
</div>
